export default "__VITE_ASSET__2748e9a8__"